export default "__VITE_ASSET__DCVFYkuR__"